import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {environment} from '../environments/environment';
import {AngularFireModule} from '@angular/fire/compat';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';
import {AngularFirestoreModule, USE_EMULATOR as USE_FIRESTORE_EMULATOR } from '@angular/fire/compat/firestore';
import {AngularFireStorageModule} from '@angular/fire/compat/storage';
import {AngularFireFunctionsModule, USE_EMULATOR as USE_FUNCTIONS_EMULATOR} from '@angular/fire/compat/functions';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from './shared.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {RSDebuggerModule} from '../libs/rsdebugger/rsdebugger.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,

    SharedModule.forRoot(),

    /* Firebase */
    AngularFireModule.initializeApp(environment.firebase), // AppScreens
    AngularFireAuthModule,
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireStorageModule, // imports firebase/storage only needed for storage features
    AngularFireFunctionsModule,

    FormsModule,
    ReactiveFormsModule,

    RSDebuggerModule,

    RecaptchaV3Module
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {provide: RECAPTCHA_V3_SITE_KEY, useValue: '6Lcj2GIaAAAAAB4xyyzzd_lEGmEX_vPv3Wb1cQ4j'},
    // (environment.useEmulators)
    //   ? [
    //     {provide: USE_FIRESTORE_EMULATOR, useValue: ['localhost', 8786]},
    //     {provide: USE_FUNCTIONS_EMULATOR, useValue: ['localhost', 5001]},
    //   ]
    //   : []
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
